import React from 'react';
import {SectionTextMedia} from "../components";
import { media } from "utils/media";
import PropTypes from 'prop-types';
import isExternalUrl from "../utils/isExternalUrl";

const SectionTextMediaWrap = ({content, locale, buttonClass}) => {
  // First button props
  const external = content.buttonUrl && isExternalUrl(content.buttonUrl);
  let buttonObj = null;
  if(content.buttonUrl && content.buttonText) {
    buttonObj = {
      label: content.buttonText,
      path: content.buttonUrl,
      level: buttonClass,
      external: external,
      newTab: content.buttonNewTab,
    }
  }

  // Other button props
  const externalOther = content.otherButtonUrl && isExternalUrl(content.otherButtonUrl);
  let otherButtonObj = null;
  if(content.otherButtonText && content.otherButtonUrl) {
    otherButtonObj = {
      label: content.otherButtonText,
      path: content.otherButtonUrl,
      level: buttonClass,
      external: externalOther,
      newTab: content.otherButtonNewTab,
    }
  }

  return (
    <SectionTextMedia
      enabled={content.enabled}
      title={content.title}
      hint={content.hint}
      subtitle={content.subtitle}
      text={content.text}
      button={buttonObj}
      otherButton={otherButtonObj}
      image={{ url: media(content.image), alt: content.title }}
      reverse={content.reverse}
      lightbox={content.lightbox}
      isVideo={content.isVideo}
      videoUrl={content.videoUrl}
      locale={locale}
      priceUk={content.priceUk}
      priceEn={content.priceEn}
      priceSe={content.priceSe}
    />
  );
}

SectionTextMedia.propTypes = {
  className: PropTypes.string.isRequired,
}

SectionTextMedia.defaultProps = {
  className: '',
};

export default SectionTextMediaWrap;